import Link from 'next/link'
import type { FC } from 'react'

import Avatar from '@components/ui/Avatar'

interface CommunityHeaderProps {
  includeLink?: { label: string; href: string }
  title: string
  author?: {
    name?: string
    iconUrl?: string
  }
  ctaButton?: any
}

export const CommunityHeader: FC<CommunityHeaderProps> = ({
  includeLink,
  title,
  author,
  ctaButton,
}) => {
  return (
    <div>
      {includeLink && (
        <Link
          href={includeLink.href}
          className="mb-6 inline-block text-sm text-sky-400 transition hover:text-sky-300"
        >
          {includeLink.label}
        </Link>
      )}
      <div className="mb-8 flex flex-row items-center gap-4">
        <div className="flex-grow">
          <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
          {author && (
            <div className="mt-1 flex flex-row items-center">
              <Avatar
                size="large"
                name={author?.name}
                avatarUrl={author?.iconUrl}
                noBackground
              />
              <p className="ml-2 text-sm text-neutral-600">By {author?.name}</p>
            </div>
          )}
        </div>
        {ctaButton}
      </div>
    </div>
  )
}

export default CommunityHeader
